module.exports = __webpack_public_path__ + "img/PlayStoreQR2.3409815d.svg";